module.exports = __webpack_public_path__ + "media/common/images/video-icon-d78232b22b57a7a841a46d6bd0ffc57c.svg";